import React from 'react';

import { DeploymentSelect } from '../../Types';
import { DeployPipeline } from '../DeployPipeline';

interface DetailsPromoteProps {
  close: () => void;
  deploymentSelected: DeploymentSelect;
  realm: string;
  triggers: any[];
  find: ({
    realm,
    environment,
    search: { projectId, projectName }
  }: {
    realm: string;
    environment: string;
    search: {
      projectId: string;
      projectName: string;
    };
  }) => void;
  create: (payload: unknown, meta: unknown, useV2Api?: boolean) => void;
  changeEnvironment: (environment: string) => void;
  remove: ({
    realm,
    deployment,
    environment
  }: {
    realm: string;
    deployment: string;
    environment: string;
  }) => void;
}

const DetailsPromote: React.FC<DetailsPromoteProps> = ({
  close,
  deploymentSelected,
  realm,
  triggers,
  find,
  create,
  changeEnvironment,
  remove
}) => (
  <DeployPipeline
    enviromentsOptions={deploymentSelected.enviromentsOptions}
    close={close}
    realm={realm}
    environment={deploymentSelected.newEnvironment}
    createDeploy={create}
    loading={false}
    triggers={triggers}
    find={find}
    showPromote
    deploymentSelected={deploymentSelected}
    changeEnvironment={changeEnvironment}
    remove={remove}
    onCloseClick={close}
  />
);

export default DetailsPromote;
